module.exports = "/static-assets/_next/static/images/conjure-51ea971241d1024bd21ca7bbc7cf6ec1.png";